<template>
	<h1>
		<slot/>
	</h1>
</template>

<script>
	export default {
		name: "Heading",
	}
</script>

<style lang="scss" scoped>

	$fa-font-path: "../../assets/fonts";
	$img-path: "../../assets/img";

	@import "~cssteudter-bootstrap-theme/scss/main";

	h1 {
		@extend .border-bottom;
		@extend .pb-2;
		@extend .mb-5;
		@extend .d-inline-block;
		min-width: 35%;
	}
</style>
